__turbopack_context__.v({
  "active": "sub-header-module-sass-module__Vel8pG__active",
  "hot": "sub-header-module-sass-module__Vel8pG__hot",
  "live": "sub-header-module-sass-module__Vel8pG__live",
  "new": "sub-header-module-sass-module__Vel8pG__new",
  "popular": "sub-header-module-sass-module__Vel8pG__popular",
  "subHeader": "sub-header-module-sass-module__Vel8pG__subHeader",
  "top": "sub-header-module-sass-module__Vel8pG__top",
});
